<template>
  <div class="games">
    <page-header titleName="GAMES" />
    <div class="games-content content">
      <div class="message">
        <p>{{ msg }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '../components/pageHeader'
export default {
  title: 'Game - α-Stella',
  components: { PageHeader },
  props: {
    msg: {
      type: String,
      default: '※ まだゲームは公開されていません ※'
    }
  }
}
</script>

<style scoped lang="scss">
@import '../styles/definitions.scss';
.message {
  padding: 50px 0px 0px 0px;
  background-color: $kContentColorMain;
  border-radius: 10px;
  margin: 20px;
  height: 100vh;
  text-align: center;
  font-size: 20px;
  color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/pages/Games.vue